import { render, staticRenderFns } from "./UiMarketOrderDetail.vue?vue&type=template&id=34d42dc1&"
import script from "./UiMarketOrderDetail.vue?vue&type=script&lang=js&"
export * from "./UiMarketOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports